import Axios from 'axios';

export const events = {
    getAll : async (event)=>{

        return await Axios.get(`/api/events`);
    }
}
